import { server_url } from "@script/config";
import type { UserData } from "@vTypes/user-type.ts";
// const server_url = `${import.meta.env.VITE_API_BASE_URL}`;

export async function login(body: URLSearchParams) {
  try {
    const response = await fetch(`${server_url}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
      credentials: "include", // ★ 쿠키 저장 + 이후 요청에 전송
    });
    console.log("login response : ", response);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "저장에 실패했습니다.");
    }
    const result = await response.json();

    return result;
  } catch (error) {
    alert("error !!");
  }
}

// 로그인 유저데이터
export async function loadLoginUser() {
  try {
    const response = await fetch(`${server_url}/auth/me`, {
      credentials: "include",
    });
    if (response.status === 401) return null;
    if (!response.ok) return null;

    const result: UserData = await response.json();
    // throw new Error("error");
    // console.log("### loadLoginUser result : ", result);
    return result;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    // console.error("Error fetching user data:");
  }
}

export async function logout() {
  try {
    const response = await fetch(`${server_url}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) console.error("logout error");

    document.cookie = "onmaumLogin=; path=/; max-age=0";
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("logout error");
  }
}

export async function fetchTokenFromMeditong(memberid: string) {
  const dataKey = "meditong11**";
  const payload = new URLSearchParams();
  payload.append("dataKey", dataKey); // key: dataKey
  payload.append("memberid", memberid); // key: dataKey

  try {
    const response = await fetch(
      `https://www.meditong.com/renewal/airoster_token_api.asp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded", // ASP에 적합한 타입
        },
        credentials: "include",
        body: payload.toString(),
      }
    );
    console.log("meditong fetch result : ", response);
    const result = await response.json();
    console.log("!!meditong fetch result : ", result);
    return result;
  } catch (error) {
    console.error("error, ", error);
  }
}

export async function tokenlogin(token: any) {
  const formData = new FormData();
  formData.append("token", token.token);
  formData.append("MemberID", token.memberid); // 이미지가 문자열이라면
  try {
    const response = await fetch(`${server_url}/token/login`, {
      method: "POST",
      body: formData,
      credentials: "include", // ★ 쿠키 저장 + 이후 요청에 전송
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error, ", error);
  }
}
